import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function QueueIcon(props: IconProps) {
    return <Icon {...props} iconKey={"queue"}/>
}
